<template>
  <div class="contianer">
    <n-data-table
      ref="table"
      size="large"
      :columns="columns"
      :single-line="false"
      :data="daySchedule"
    />
  </div>
</template>
<script>
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
//import { FirebaseDataService } from '../services/FirebaseDataServices';
export default defineComponent({
  setup() {
    const store = useStore();
    const columns = createColumns();
    const daySchedule = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.daySchedule)),
      ),
    );
    const MonthSchedule = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.monthSchedule)),
      ),
    );
    onMounted(async () => {
      await store.dispatch('monthScheduleLoad').then(() => {});
      //FirebaseDataService.realtimeAwait();
    });
    function createColumns() {
      return [
        {
          title: 'ผู้บริหาร',
          key: 'board',
          width: 110,
          rowSpan: (rowData, rowIndex) =>
            rowIndex === rowData.rowIndex ? rowData.desLength : 1,
        },
        {
          title: 'เวลา',
          key: 'time',
          width: 70,
        },
        {
          title: 'วาระงาน',
          key: 'description',
          render(row) {
            return row.description;
          },
        },
      ];
    }
    return {
      columns,
      daySchedule,
      MonthSchedule,
      createColumns,
    };
  },
});
</script>
